import React from 'react';

/**
 * Master brand logo — full lockup (mark + wordmark on transparent-looking
 * black background). Use across all app surfaces so we stay on-brand.
 *
 * Sizes are just Tailwind width helpers; height auto-scales.
 *   • hero:    w-56 sm:w-64 md:w-72
 *   • medium:  w-40
 *   • compact: w-28
 *   • tiny:    w-16 (favicon-ish header)
 */
export default function BrandLogo({ className = 'w-40', alt = 'Facade Lighting Studio' }) {
  return (
    <img
      src="/logo.png"
      alt={alt}
      draggable={false}
      className={`select-none pointer-events-none ${className}`}
      data-testid="brand-logo"
    />
  );
}
